"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _static = require("../static");
var _TransportTrace = _interopRequireDefault(require("../components/TransportTrace.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    TransportTrace: _TransportTrace.default
  },
  name: 'OrderDetail',
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      reverse: true,
      // 初始化 reverse 属性
      dialogVisible: false,
      orderDatalist: {
        store: {},
        // 初始化 store 为一个空对象
        platformCarmine: {},
        // 初始化 platformCarmine 为一个空对象
        orderItemList: [],
        // 初始化 orderItemList 为空数组
        orderLogList: [],
        // 初始化 orderLogList 为空数组
        kuaiDiInfoList: [],
        // 初始化 kuaiDiInfoList 为空数组
        orderPay: {},
        // 初始化 orderPay 为空对象
        orderDelivery: {},
        // 初始化 orderDelivery 为空对象
        type: 0 // 初始化订单类型
      },
      loading: false,
      result: [],
      baseOption: [
      // 订单基础信息
      {
        title: '订单编号',
        dataIndex: 'orderNo'
      }, {
        title: '订单状态',
        dataIndex: 'statusName'
      }, {
        title: '下单时间',
        dataIndex: 'createTime'
      }, {
        title: '付款时间',
        dataIndex: 'payTime'
      }, {
        title: '完结时间',
        dataIndex: 'endTime'
      }, {
        title: '取消时间',
        dataIndex: 'cancelTime'
      }, {
        title: '结算金额',
        dataIndex: 'totalSupplierPrice'
      }, {
        title: '订单标签',
        dataIndex: 'orderTagStr'
      }, {
        title: '客户备注',
        dataIndex: 'userRemark'
      }
      // {title: '物流状态', dataIndex: 'deliveryStatusName'}, 
      // {title: '关联售后', dataIndex: 'saleAfter'},
      // {title: '订单标签', dataIndex: 'orderTagStr'},
      // {title: '客户备注', dataIndex: 'userRemark'},
      // // 新增时间信息
      // {title: '下单时间', dataIndex: 'createTime'},
      // {title: '付款时间', dataIndex: 'payTime'},
      // {title: '发货时间', dataIndex: 'shipmentsTime'},
      ],
      transportOption: [
      // 物流相关 // orderDelivery
      {
        title: '收货人',
        dataIndex: 'receiverName'
      }, {
        title: '收货电话',
        dataIndex: 'receiverPhone'
      }, {
        title: '收货地址',
        dataIndex: 'receiverAddress'
      }],
      payOption: [{
        title: '支付方式',
        dataIndex: 'payTypeName'
      }],
      priceOption: [
      // 支付明细
      {
        title: '订单总价',
        dataIndex: 'totalPrice',
        widthAll: true
      }, {
        title: '运费',
        dataIndex: 'freight',
        widthAll: true,
        uint: '+'
      }, {
        title: '优惠',
        dataIndex: 'discount',
        isWarning: true,
        widthAll: true,
        uint: '-'
      }, {
        title: '积分抵扣',
        dataIndex: 'useIntegral',
        widthAll: true,
        uint: '-'
      }, {
        title: '卡劵抵扣',
        dataIndex: 'couponPrice',
        isWarning: true,
        widthAll: true,
        uint: '-'
      }, {
        title: '订单实付款',
        dataIndex: 'paidPrice',
        widthAll: true
      }],
      store: [
      // 蛋糕门店信息
      {
        title: '城市名称',
        dataIndex: 'cityName',
        widthAll: false,
        uint: ''
      }, {
        title: '门店名称',
        dataIndex: 'storeName',
        widthAll: false,
        uint: ''
      }, {
        title: '门店电话',
        dataIndex: 'storePhone',
        widthAll: true,
        uint: ''
      }, {
        title: '门店地址',
        dataIndex: 'storeAddr',
        widthAll: true,
        uint: ''
      }],
      thirdPartyCouponInfo: [{
        title: "充值账号",
        dataIndex: "accounts"
      }, {
        title: "供应商订单号",
        dataIndex: "supplierNo"
      }, {
        title: "最后更新时间",
        dataIndex: "updateTime"
      }, {
        title: "三方状态",
        dataIndex: "thirdPartyStatusDesc"
      }],
      diningInfo: [{
        title: "供应商订单编号",
        dataIndex: "supplierNo"
      }, {
        title: "三方状态",
        dataIndex: "thirdPartyStatusDesc"
      }],
      housekeepingInfo: [{
        title: "供应商订单编号",
        dataIndex: "supplierNo"
      }, {
        title: "预约时间",
        dataIndex: "appointmentTime"
      }, {
        title: "上门地址",
        dataIndex: "address"
      }, {
        title: "三方状态",
        dataIndex: "thirdPartyStatusDesc"
      }],
      cakeInfo: [{
        title: "供应商订单编号",
        dataIndex: "supplierNo"
      }, {
        title: "送货时间",
        dataIndex: "deliveryTime"
      }, {
        title: '城市名称',
        dataIndex: 'cityName'
      }, {
        title: '门店名称',
        dataIndex: 'storeName'
      }, {
        title: '门店电话',
        dataIndex: 'storePhone'
      }, {
        title: '门店地址',
        dataIndex: 'storeAddr'
      }, {
        title: "三方状态",
        dataIndex: "thirdPartyStatusDesc"
      }],
      selfOperatedCouponInfo: [{
        title: "卡号",
        dataIndex: "cardNo"
      }, {
        title: "过期时间",
        dataIndex: "dueTime"
      }, {
        title: "卡密",
        dataIndex: "carmine"
      }, {
        title: "关联ID",
        dataIndex: "skuId"
      }, {
        title: "核销码",
        dataIndex: "qrCode"
      }],
      orderNo: null,
      logisticsLoading: false
    };
  },
  mounted: function mounted() {},
  methods: {
    transformState: _transformState.default,
    // 查询详情
    openDetail: function openDetail(orderNo) {
      this.orderNo = orderNo;
      if (!orderNo) {
        this.$message.warning('未查询到该订单！');
        return;
      }
      ;
      this.getOrderData(orderNo);
    },
    // 追踪物流
    openLogistics: function openLogistics(nu) {
      var logisticsInfo = this.orderDatalist.kuaiDiInfoList && this.orderDatalist.kuaiDiInfoList.find(function (info) {
        return info && info.nu === nu;
      });
      if (logisticsInfo) {
        // 确保物流信息中有正确的物流公司名称
        if (!logisticsInfo.deliveryName) {
          logisticsInfo.deliveryName = this.getDeliveryName(logisticsInfo);
        }
        this.$refs['TransportTraceRef'].initOpen([logisticsInfo]);
      } else {
        this.$message.warning('没有物流信息');
      }
    },
    // 路由到售后单详情页面
    navigateToAftersaleDetail: function navigateToAftersaleDetail(aftersaleId) {
      this.$router.push({
        path: "/order/aftersale/aftersaleDetail/".concat(aftersaleId, "/").concat(this.orderNo, "/2")
      });
    },
    // 获取订单物流信息
    getOrderData: function getOrderData(orderNo) {
      var _this = this;
      this.dialogVisible = true;
      this.loading = true;
      orderListApi.getOrderDetail2(orderNo).then(function (res) {
        try {
          console.log("API Response:", JSON.stringify(res));
          if (!res) {
            throw new Error('获取订单详情失败');
          }
          console.log("Order type:", res.type);

          // 先创建一个完整的数据结构，确保所有属性都有默认值
          var defaultData = {
            orderDelivery: {},
            orderPay: {},
            orderItemList: [],
            kuaiDiInfoList: [],
            orderLogList: [],
            platformCarmine: {},
            storeDetail: {},
            type: res.type || 0,
            status: res.status || '',
            statusName: res.statusName || '',
            tagName: '',
            tagRemark: '',
            orderTagStr: '',
            dynamicFormInfo: null
          };

          // 将API返回的数据合并到默认数据中
          var mergedData = _objectSpread(_objectSpread({}, defaultData), res);

          // 特殊处理自营卡券订单
          if (mergedData.type === 12) {
            console.log("Processing type 12 order");
            mergedData.platformCarmine = mergedData.platformCarmine || {};
          }
          if (mergedData.dynamicFormInfo) {
            mergedData.dynamicFormInfo.formItems = mergedData.dynamicFormInfo.formItems || [];
            mergedData.dynamicFormInfo.formItems.forEach(function (item) {
              if (item.type === 'checkbox' && item.value && !item.value.startsWith('[')) {
                item.value = JSON.stringify(item.value.split(',').map(function (value) {
                  return value.trim();
                }).filter(Boolean));
              }
            });
          }

          // 处理kuaiDiInfoList，为每个物流信息添加物流公司名称
          if (mergedData.kuaiDiInfoList && mergedData.kuaiDiInfoList.length > 0) {
            var companyMap = {
              'shentong': '申通快递',
              'ems': 'EMS快递',
              'youzhengguonei': '邮政快递',
              'yuantong': '圆通快递',
              'shunfeng': '顺丰快递',
              'yunda': '韵达快递',
              'zhongtong': '中通快递',
              'jd': '京东物流',
              'tiantian': '天天快递',
              'debangwuliu': '德邦物流',
              'huitongkuaidi': '百世快递'
            };

            // 处理物流信息
            mergedData.kuaiDiInfoList.forEach(function (item) {
              if (item && !item.deliveryName) {
                // 尝试从orderDelivery中获取快递公司名称
                if (mergedData.orderDelivery && mergedData.orderDelivery.orderDeliveryList && mergedData.orderDelivery.orderDeliveryList.length > 0) {
                  var matchedDelivery = mergedData.orderDelivery.orderDeliveryList.find(function (delivery) {
                    return delivery.deliveryNo === item.nu;
                  });
                  if (matchedDelivery && matchedDelivery.deliveryCompany) {
                    item.deliveryName = matchedDelivery.deliveryCompany;
                  } else if (item.com && companyMap[item.com]) {
                    item.deliveryName = companyMap[item.com];
                  } else {
                    item.deliveryName = '未知物流公司';
                  }
                } else if (item.com && companyMap[item.com]) {
                  item.deliveryName = companyMap[item.com];
                } else {
                  item.deliveryName = '未知物流公司';
                }
              }
            });
          }

          // 处理orderItemList，确保aftersaleAndAmount属性存在
          if (Array.isArray(mergedData.orderItemList)) {
            mergedData.orderItemList = mergedData.orderItemList.map(function (item) {
              if (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  aftersaleAndAmount: item.aftersaleAndAmount || []
                });
              }
              return null;
            }).filter(Boolean);
          }

          // 确保orderDelivery有值
          mergedData.orderDelivery = mergedData.orderDelivery || {};

          // 确保orderPay有值
          mergedData.orderPay = mergedData.orderPay || {};

          // 添加orderTagStr属性
          mergedData.orderTagStr = "".concat(mergedData.tagName || '', "-").concat(mergedData.tagRemark || '');
          console.log("Final processed data:", JSON.stringify(mergedData));

          // 更新组件状态
          _this.orderDatalist = mergedData;
        } catch (error) {
          console.error('Error processing order details:', error);
          _this.$message.error('处理订单详情数据出错: ' + (error.message || '未知错误'));
        } finally {
          _this.loading = false;
        }
      }).catch(function (err) {
        console.error('Error loading order details:', err);
        _this.loading = false;
        _this.$message.error('获取订单详情失败: ' + (err.message || '未知错误'));
      });
    },
    getDeliveryName: function getDeliveryName(logisticsInfo) {
      // 首先尝试使用 logisticsInfo 中的 deliveryName
      if (logisticsInfo.deliveryName) {
        return logisticsInfo.deliveryName;
      }

      // 如果没有，尝试从 orderDelivery 中获取对应的快递公司名称
      if (this.orderDatalist && this.orderDatalist.orderDelivery && this.orderDatalist.orderDelivery.orderDeliveryList && this.orderDatalist.orderDelivery.orderDeliveryList.length > 0) {
        // 尝试匹配物流单号
        var delivery = this.orderDatalist.orderDelivery.orderDeliveryList.find(function (item) {
          return item.deliveryNo === logisticsInfo.nu;
        });
        if (delivery && delivery.deliveryCompany) {
          return delivery.deliveryCompany;
        }
      }

      // 最后尝试使用快递公司编码映射到名称
      var companyMap = {
        'shentong': '申通快递',
        'ems': 'EMS快递',
        'youzhengguonei': '邮政快递',
        'yuantong': '圆通快递',
        'shunfeng': '顺丰快递',
        'yunda': '韵达快递',
        'zhongtong': '中通快递',
        'jd': '京东物流',
        'tiantian': '天天快递',
        'debangwuliu': '德邦物流',
        'huitongkuaidi': '百世快递'
      };
      if (logisticsInfo.com && companyMap[logisticsInfo.com]) {
        return companyMap[logisticsInfo.com];
      }

      // 如果都没有找到，返回默认值
      return '未知物流公司';
    },
    getFormItemTypeName: function getFormItemTypeName(type) {
      var typeMap = {
        input: '单行文本',
        textarea: '多行文本',
        select: '下拉选择',
        radio: '单选按钮',
        checkbox: '多选按钮',
        dateSelect: '日期',
        phone: '电话号码',
        tips: '说明文本'
      };
      return typeMap[type] || type;
    },
    getFormItemTagType: function getFormItemTagType(type) {
      var typeTagMap = {
        input: '',
        textarea: 'info',
        select: 'warning',
        radio: 'success',
        checkbox: 'primary',
        dateSelect: 'warning',
        phone: 'danger',
        tips: 'info'
      };
      return typeTagMap[type] || '';
    },
    formatFormValue: function formatFormValue(item) {
      if (!item.value) return '--';
      if (item.type === 'checkbox') {
        var values = this.parseFormValue(item.value);
        return values.length ? values.join(', ') : item.value;
      }
      return item.value;
    },
    parseFormValue: function parseFormValue(value) {
      if (!value) return [];
      try {
        var parsedValue = JSON.parse(value);
        return Array.isArray(parsedValue) ? parsedValue.map(function (item) {
          return typeof item === 'string' ? item.trim() : item;
        }).filter(Boolean) : [];
      } catch (e) {
        return [];
      }
    },
    formatPhoneNumber: function formatPhoneNumber(value) {
      if (!value) return '--';
      var cleaned = value.replace(/\D/g, '');
      if (cleaned.length === 11) {
        return "".concat(cleaned.substring(0, 3), "-").concat(cleaned.substring(3, 7), "-").concat(cleaned.substring(7));
      }
      return value;
    },
    copyFormData: function copyFormData(formData) {
      var _this2 = this;
      if (!formData || !formData.formItems || formData.formItems.length === 0) {
        this.$message.warning('没有可复制的表单数据');
        return;
      }
      var formattedData = "\u8868\u5355\u6807\u9898: ".concat(formData.title || '无标题', "\n");
      formattedData += "\u63D0\u4EA4\u65F6\u95F4: ".concat(formData.submitTime || '未知', "\n\n\u8868\u5355\u5185\u5BB9:\n");
      formData.formItems.forEach(function (item, index) {
        formattedData += "".concat(index + 1, ". ").concat(item.title || '未命名', ": ").concat(_this2.formatFormValue(item), "\n");
      });
      var textarea = document.createElement('textarea');
      textarea.value = formattedData;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      var success = document.execCommand('copy');
      document.body.removeChild(textarea);
      success ? this.$message.success('表单数据已复制到剪贴板！') : this.$message.error('复制失败，请手动复制');
    }
  }
};